export function truncate(string: string, maxLength = 10): string {
  if (string.length <= maxLength) {
    return string;
  }

  const parts = string.split(' ');
  const firstPart = parts[0];
  const lastPart = parts[1] && parts[1].match(/^[A-Za-z]/g);
  if (!lastPart) {
    return firstPart;
  }

  return `${firstPart} ${lastPart}.`;
}
